import { useCallback } from "react";
import { useAppContext } from "./useAppContext";
import { useMessage } from "./useMessage";

/**
 * Sets the domument title
 */
export function useDocumentTitle() {
	const { editor } = useAppContext();

	useMessage(
		useCallback(
			(message) => {
				const def = editor.definition;
				if (def && eXpress.core.shouldUpdateDocumentTitle(message)) {
					// Set document title
					document.title = def.name ? def.name : def.product.name;
				}
			},
			[editor.definition],
		),
	);
}
